import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { AppSettings } from '../settings/app.settings';
import { HrefLang, HrefLangDefinition } from '../shared/hreflang.service';
import { SEOService } from '../shared/seo-service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class FaqComponent implements OnInit {
  public questions: any = [
    { title: 'FAQ1', answer: 'ANSW1'},
    { title: 'FAQ2', answer: 'ANSW2'},
    { title: 'FAQ3', answer: 'ANSW3'},
    { title: 'FAQ4', answer: 'ANSW4'},
    { title: 'FAQ5', answer: 'ANSW5'},
    { title: 'FAQ6', answer: 'ANSW6'},
    { title: 'FAQ7', answer: 'ANSW7'},
    { title: 'FAQ8', answer: 'ANSW8'},
    { title: 'FAQ9', answer: 'ANSW9'},
    { title: 'FAQ10', answer: 'ANSW10' },
    { title: 'FAQ11', answer: 'ANSW11' },
    { title: 'FAQ12', answer: 'ANSW12' },
    { title: 'FAQ13', answer: 'ANSW13' },
    { title: 'FAQ14', answer: 'ANSW14' },
    { title: 'FAQ15', answer: 'ANSW15' },
    { title: 'FAQ16', answer: 'ANSW16' },
    { title: 'FAQ17', answer: 'ANSW17' },
  ];
  public questionsList: Question[] = [];
  public auxListQuestion: Question[] = [];
  public noQuestion = false;
  public searchText = '';

  constructor(
    private meta: Meta,
    private translate: TranslateService,
    private seoService: SEOService,
    private title: Title,
    private hlang: HrefLang,
  ) {}
  ngOnInit() {
    this.seoService.createLinkForCanonicalURL('');
    this.translate.get('META_TITLE_FAQ').subscribe(text => {
      this.title.setTitle(text);
    });
    this.translate.get('META_DESC_FAQ').subscribe(text => {
      const tag: MetaDefinition = {
        name: 'description',
        content: text
      };
      this.meta.addTags([tag]);
    });
    const langs = [
      { lang: 'es', text: 'preguntas-frecuentes' },
      { lang: 'en', text: 'frequently-asked-questions' }//,
      // { lang: 'fr', text: 'foire-aux-questions' },
      // { lang: 'it', text: 'domande-frequenti' },
      // { lang: 'de', text: 'haufig-gestellte-fragen' }
    ];
    langs.forEach(lang => {
      const hreflang_: HrefLangDefinition = {
        rel: 'alternate',
        href: `${AppSettings.BASE_DOMAIN}/${lang.lang}/${lang.text}`,
        hreflang: `${lang.lang}`
      };
      this.hlang.addTags([hreflang_]);
    });

    this.createTransalteQuestions(this.questions);
  }

  /**
   * Use Translate service
   */
  private createTransalteQuestions(questions) {
    questions.map((el, index) => {
      index++;
      this.translate.get([el.title, el.answer]).subscribe(res => {
        this.auxListQuestion.push({ title: res['FAQ' + index], answer: res['ANSW' + index]});
        this.questionsList.push({ title: res['FAQ' + index], answer: res['ANSW' + index]});
      });
    });
  }

  /**
   * Text obtained from input
   * @param event search word
   */
  searchWord(event: any) {
    this.searchText = event.target.value;
    if (this.searchText.length >= 3) {
      this.getWord(this.searchText);
    } else {
      this.noQuestion = false;
      this.auxListQuestion = [...this.questionsList];
    }
  }

  /**
   * They will show, if they have, matches with this word (in the questions)
   * @param word word with more than 3 syllables
   */
  private getWord(word: string) {
    word = word.toLowerCase();
    this.auxListQuestion = [];
    this.auxListQuestion =  this.questionsList.filter(el => 
      (el.title.toLowerCase().includes(word) || el.answer.toLowerCase().includes(word)) 
      );
    if (this.auxListQuestion.length > 0) {
      this.noQuestion = false;
    } else {
      this.noQuestion = true;
    }
  }
}



export interface Question {
  title: string;
  answer: string;
}
